<script setup>
import { useRoute } from "vue-router";
import { watch } from "vue";

const route = useRoute();

watch(
  () => route,
  (to) => {
    document.title =
      to.meta.title ||
      to.params[to.meta.paramKey] ||
      to.meta.label ||
      to.name ||
      "Mazars";
  },
  { deep: true }
);
</script>

<template>
  <router-view></router-view>
</template>
